import React from 'react';
import { CompanyName, DateInvoice, PaymentMethod, StatusClosingDate, UsagePlan, YenItem } from './listInvoiceTableStyle';
import { CONST_LIST_INVOICE_COMPANY, CONST_OPERATOR_INVOICE } from 'constants/language';
import { ButtonView } from '@containers/AgencySite/InvoiceItem/invoiceItemStyle';
import { formatMoney } from 'helper/formatMoney';
import { formatDateCommon } from 'helper/date';
import { Tooltip } from 'antd';
import { DEPOSIT_TYPE, PAYMENT_METHOD_BANK_TRANSFER, PAYMENT_METHOD_DIRECT_DEBIT } from 'constants/invoice';
import { isNotDateDueYet } from 'helper';
import { SpaceBase } from 'styles';

const USAGE_PLAN_AGENCY_TEXT = ['', CONST_OPERATOR_INVOICE.DEPOSIT, CONST_OPERATOR_INVOICE.REIMBURSEMENT];
export const DataInvoice = ({ item, navigate, paramSearch, isParent = false }: any) => {
  const displayName = item.company_name_prefix ?
    `（${item.company_name_prefix}）${item.company_name}` : item.company_name;
  return (
    <>
      <Tooltip placement="leftTop" title={item.company_name}>
        <CompanyName>{displayName}</CompanyName>
      </Tooltip>
      <DateInvoice>{formatDateCommon(item.release_date)}</DateInvoice>
      <DateInvoice>{formatDateCommon(item.deadline_transfer)}</DateInvoice>
      <YenItem>{formatMoney(item.total_payment || 0)}</YenItem>
      <UsagePlan>{USAGE_PLAN_AGENCY_TEXT[Number(item.usage_plan) || 0]}</UsagePlan>
      {Number(paramSearch.usage_plan) === DEPOSIT_TYPE && (
        <PaymentMethod>{(item.payment_method === PAYMENT_METHOD_DIRECT_DEBIT) ? '口座振替' : '銀行振込'}</PaymentMethod>
      )}
      {Number(paramSearch.usage_plan) !== DEPOSIT_TYPE && (
        <StatusClosingDate>
          {isNotDateDueYet(item.closing_date)
            ? CONST_OPERATOR_INVOICE.LIST_INVOICE_COMPANY_TABLE.STATUS_CLOSING_DATE
            : CONST_OPERATOR_INVOICE.LIST_INVOICE_COMPANY_TABLE.STATUS_CLOSING_DATE_APPROVED}
        </StatusClosingDate>
      )}
      <ButtonView
        fontSize="1.25rem"
        fontWeight="500"
        height="2.5rem"
        width="7.5rem"
        borderRadius="0.25rem"
        onClick={() => {
          if (isParent) navigate(`/company-invoices/detail/${item.key_id}_all`);
          else navigate(`/company-invoices/detail/${item.key_id}`);
        }}
      >
        {CONST_LIST_INVOICE_COMPANY.CONFIRM_INVOICE}
      </ButtonView>
    </>
  );
};
